import { useEffect, useState } from 'react';

export type GetUpdateMessageArgs = {
    addCount: number;
    isAddPlural: boolean;
    removeCount: number;
    isRemovePlural: boolean;
};

export type UseIdListArgs = {
    initialIdList: string[];
    getUpdateMessage: (args: GetUpdateMessageArgs) => string;
};

export type UseIdListReturnValue = {
    idList: string[];
    addId: (id: string) => void;
    removeId: (id: string) => void;
    updateMessage: string;
    resetIdList: () => void;
};

export default function useIdList({ initialIdList, getUpdateMessage }: UseIdListArgs): UseIdListReturnValue {
    const initialListUpdateKey = initialIdList.sort().join(',');
    const [idList, setIdList] = useState(initialIdList);
    // reflect updates from parent
    useEffect(() => {
        setIdList(initialIdList);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialListUpdateKey]);

    const addId = (id: string) => {
        if (!idList.includes(id)) {
            setIdList([...idList, id]);
        }
    };

    const removeId = (id: string) => {
        if (idList.includes(id)) {
            setIdList(idList.filter((_) => _ !== id));
        }
    };

    const generateUpdateMessage = () => {
        const addCount = idList.filter((id) => !initialIdList.includes(id)).length;
        const removeCount = initialIdList.filter((id) => !idList.includes(id)).length;

        if (!addCount && !removeCount) return null;

        return getUpdateMessage({
            addCount,
            isAddPlural: addCount !== 1,
            removeCount,
            isRemovePlural: removeCount !== 1,
        });
    };

    return {
        idList,
        addId,
        removeId,
        // @ts-expect-error TS2322
        updateMessage: generateUpdateMessage(),
        resetIdList: () => setIdList(initialIdList),
    };
}
